export enum DocumentTypesEnum {
  FOLDER = 'Folder',
  DOCUMENT = 'Document',
  PLAN = 'Ifc',
}
